import { NgModule } from '@angular/core'
import { CommonModule } from '@angular/common'
import { DynamicsModuleComponent } from './dynamics-module.component'
import { DynamicsModuleDirective } from './dynamics-module.directive'
import { ReactiveSearchModule } from '../reactive-search/reactive-search.module'
import { LogosLinkModule } from '../logos-link/logos-link.module'



@NgModule({
  declarations: [DynamicsModuleComponent, DynamicsModuleDirective],
  imports: [
    CommonModule,
    ReactiveSearchModule,
    LogosLinkModule
  ],
  exports: [DynamicsModuleComponent]
})
export class DynamicsModuleModule { }
